import React from "react";
import BlogSection from "../components/BlogSection";
import IconHovers from "../components/IconHovers";


const Home = () => {
  return (
    <div className="blog-div">
      <BlogSection />
      <IconHovers />
    </div>
  );
};

export default Home;
